const getImageUrl = place => 'https://i.imgur.com/' + place.imageId + 'l.jpg';

export { getImageUrl };
